import { Flex, Typography } from 'antd'
import styled from 'styled-components'

export const Content = styled(Flex)``

export const Description = styled(Typography.Text)`
  color: ${(props) => props.theme.colors.cardDescription};
`

export const ModeOptions = styled(Flex)``
